import {
	lightingBolt,
	luchtdebiet,
	vermogen,
} from '../assets/images/images';

export const PRODUCT_CONFIG = {
	fields: [
		'productCode',
		'dimensions',
		'weight',
		'motorPower',
		'vacumePower',
		'maxAirDebit',
		'filterSurface',
		'filterMaterial',
		'openingIntake',
		'decibel',
		'dustContainer',
		'powerSupply',
	],
	tooltips: {
		productCode: 'PRODUCT_INFO_TOOLTIP.PRODUCTCODE',
		dimensions: 'PRODUCT_INFO_TOOLTIP.DIMENSIONS',
		weight: 'PRODUCT_INFO_TOOLTIP.WEIGHT',
		filterSurface: 'PRODUCT_INFO_TOOLTIP.FILTER_SURFACE',
		powerSupply: 'PRODUCT_INFO_TOOLTIP.POWER_SUPPLY',
		motorPower: 'PRODUCT_INFO_TOOLTIP.MOTOR_POWER',
		vacumePower: 'PRODUCT_INFO_TOOLTIP.VACUME_POWER',
		maxAirDebit: 'PRODUCT_INFO_TOOLTIP.MAX_AIR_DEBIT',
		openingIntake: 'PRODUCT_INFO_TOOLTIP.OPENING_IN_TAKE',
		filterMaterial: 'PRODUCT_INFO_TOOLTIP.FILTER_MATERIAL',
		dustContainer: 'PRODUCT_INFO_TOOLTIP.DUST_CONTAINER',
		decibel: 'PRODUCT_INFO_TOOLTIP.DECIBEL',
	},
	label: {
		productCode: 'PRODUCT_INFO_LABEL.PRODUCTCODE',
		dimensions: 'PRODUCT_INFO_LABEL.DIMENSIONS',
		weight: 'PRODUCT_INFO_LABEL.WEIGHT',
		motorPower: 'PRODUCT_INFO_LABEL.MOTOR_POWER',
		vacumePower: 'PRODUCT_INFO_LABEL.VACUME_POWER',
		maxAirDebit: 'PRODUCT_INFO_LABEL.MAX_AIR_DEBIT',
		filterSurface: 'PRODUCT_INFO_LABEL.FILTER_SURFACE',
		filterMaterial: 'PRODUCT_INFO_LABEL.FILTER_MATERIAL',
		openingIntake: 'PRODUCT_INFO_LABEL.OPENING_IN_TAKE',
		decibel: 'PRODUCT_INFO_LABEL.DECIBEL',
		dustContainer: 'PRODUCT_INFO_LABEL.DUST_CONTAINER',
		powerSupply: 'PRODUCT_INFO_LABEL.POWER_SUPPLY',
	},
	// Spanning
	//  max. onderdruk
	// vermogen (zie voorbeeld armpje)
	cardIcons: {
		motorPower: { //vermogen
			label: 'PRODUCT_INFO_LABEL.MOTOR_POWER_CARD_INFO',
			src: vermogen,
		},
		vacumePower: { //max. onderdruk
			label: 'PRODUCT_INFO_LABEL.VACUME_POWER_CARD_INFO',
			src: luchtdebiet,
		},
		powerSupply: { //
			label: 'PRODUCT_INFO_LABEL.POWER_SUPPLY_CARD_INFO',
			src: lightingBolt,
		},
		// maxAirDebit: {
		// 	label: 'PRODUCT_INFO_LABEL.MAX_AIR_DEBIT_CARD_INFO',
		// 	src: '',
		// },
		// filterSurface: {
		// 	label: 'PRODUCT_INFO_LABEL.FILTER_SURFACE_CARD_INFO',
		// 	src: '',
		// },
		// filterSurface: {
		// 	label: 'PRODUCT_INFO_LABEL.FILTER_MATERIAL_CARD_INFO',
		// 	src: '',
		// },
		// openingIntake: {
		// 	label: 'PRODUCT_INFO_LABEL.OPENING_INTAKE_CARD_INFO',
		// 	src: '',
		// },
		// decibel: {
		// 	label: 'PRODUCT_INFO_LABEL.DECIBEL_CARD_INFO',
		// 	src: '',
		// },
		// dustContainer: {
		// 	label: 'PRODUCT_INFO_LABEL.DUST_CONTAINER_CARD_INFO',
		// 	src: '',
		// },
	},
	webshopUrl: "https://aertech.odoo.com/shop",
	loadLimitProductInfo: 5,
};




// WEBPACK FOOTER //
// ./src/config/product.config.js